export const loadFullPage = {
    mostrar(mensagem = 'Aguarde...') {
        let html = '';
        const _setLoader = function () {
            html = '<div id="loader-site"><div id="loader-overlay" tabindex="-1" style="opacity: 1.03;"></div><div id="loader-msg" tabindex="-1">';
            html += '<div class="modal" style="display:block;z-index:2000"><div class="modal-dialog modal-sm text-center"><div class="modal-content"><div class="modal-body" style="padding-top: 30px;padding-bottom: 30px;"><div class="spinner-border" style="margin-bottom: -8px;margin-right: 10px;" role="status"><span class="visually-hidden">Loading...</span></div> ' + mensagem + '</div></div></div></div>';

            document.body.insertAdjacentHTML("afterbegin", html);

        };
        const init = function () {
            _setLoader();
        }
        return init();
    },
    esconder() {
        const _removeLoader = function () {
            let findLoader = document.getElementById('loader-site');
            if (document.contains(findLoader)) {
                findLoader.remove();
            }
        };
        const init = function () {
            _removeLoader();
        }

        return init();
    }
};
